const resources = {
  today: (hours: string) => `KIJK VANAF ${hours}`,
  tomorrow: () => `KIJK VANAF MORGEN`,
  futureDays: (days: number) => `KIJK OVER ${days} DAGEN`,
  futureDate: (date: string) => `KIJK VANAF ${date}`
};

export default resources;
